module.exports = __webpack_public_path__ + "img/upload.c9e0ef81.png";